<template>
  <div>
    <!-- Message d'indication pendant le chargement -->
    <vs-alert v-if="loading" color="warning" title="Loading Stock Data..." class="mb-4">
      <span>We are refreshing the stock data. This process may take a few seconds. Please wait...</span>
    </vs-alert>

    <!-- Message d'alerte -->
    <vs-alert color="primary" title="Stock Alert Information" v-if="api_message && !loading" class="mb-4">
      <span>{{ api_message }}</span>
    </vs-alert>

    <!-- Tableau des alertes de stock -->
    <div v-if="stock_alerts.length > 0 && !loading">
      <vx-card title="Stock Alerts" class="mb-base">
        <vs-table :data="stock_alerts" style="overflow-x: auto;">
          <template slot="thead">
            <vs-th>Category</vs-th>
            <vs-th>Product</vs-th>
            <vs-th>Stock Alert (m³)</vs-th>
            <vs-th>Current Stock (m³)</vs-th>
            <vs-th>Projected Stock (m³)</vs-th>
            <vs-th>Outsourced</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :key="index" :data="row" v-for="(row, index) in data">
              <vs-td>{{ row.category }}</vs-td>
              <vs-td>{{ row.product }}</vs-td>
              <vs-td>{{ Number(row.alert_min).toFixed(2) }} m³</vs-td>
              <vs-td>{{ Number(row.stock_volume).toFixed(2) }} m³</vs-td>
              <vs-td>{{ Number(row.stock_after_quotation_volume).toFixed(2) }} m³</vs-td>
              <vs-td>{{ row.external_supplier ? "Yes" : "No" }}</vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </vx-card>
    </div>

    <!-- Message d'alerte si aucune donnée n'est disponible -->
    <vs-alert color="danger" title="No Alerts Found" v-else-if="!loading">
      <span>No stock alerts found.</span>
    </vs-alert>
  </div>
</template>

<script>
import axios from "@/axios.js";

export default {
  data() {
    return {
      stock_alerts: [], // Liste des alertes de stock
      api_message: "", // Message renvoyé par l'API
      loading: true, // Indique si les données sont en cours de chargement
    };
  },
  methods: {
    async fetchStockAlerts() {
      try {
        this.loading = true; // Début du chargement
        const response = await axios.get("stocks/reports/alert");

        if (response.data && response.data.success) {
          this.api_message = response.data.message; // Message API
          this.stock_alerts = response.data.data; // Liste des alertes
        } else {
          this.api_message = "No alerts available.";
        }
      } catch (error) {
        console.error("Error fetching stock alerts:", error);
        this.api_message = "Error occurred while fetching alerts.";
      } finally {
        this.loading = false; // Fin du chargement
      }
    },
  },
  created() {
    // Appel de l'API lors de la création du composant
    this.fetchStockAlerts();
  },
};
</script>

<style lang="scss">
/* Ajoutez des styles personnalisés si nécessaire */
</style>